import { createSelector } from 'reselect';
import { matchPath } from 'react-router';
import { parseLocationSearch } from 'utils';

export const selectRouterInitialLocation = (store) => store.router.initialLocation;
export const selectRouterLocation = (store) => store.router.location;
export const selectRouterPreviousLocation = (store) => store.router.previousLocation;
export const selectRouterQuery = (store) => store.router.query;
export const selectRouterGeolocation = (store) => store.router.geolocation;
export const selectGclidDependenciesReady = (store) => store.router.gclidDependenciesReady;
// export const selectStoreIdReadingReady = (store) => store.router.storeIdReadingReady;

/**
 * @deprecated for performance and clarity, consider using selectRouterMatch instead
 */
export const routerMatchPath = createSelector([(_, path) => path, selectRouterLocation], (path, { pathname }) => matchPath(pathname, { path }));

export const selectInitialQueryStringsParams = createSelector([selectRouterInitialLocation], (initialLocation) => parseLocationSearch(initialLocation));

export const hasEpoi = createSelector([selectInitialQueryStringsParams], (params) => {
  return Boolean(params?.epoi) || Boolean(params?.sf_epoi);
});

export const selectStoreId = createSelector([selectInitialQueryStringsParams], (params) => params?.storeId || params?.sf_store_id);
export const hasStoreId = createSelector([selectStoreId], (storeId) => Boolean(storeId));

export const selectCustomLabel = createSelector([selectInitialQueryStringsParams], (params) => params?.customLabel);
export const hasCustomLabel = createSelector([selectCustomLabel], (customLabel) => Boolean(customLabel));
